import TypeA from './TypeA/TypeA';
import TypeB from './TypeB/TypeB';

const ArticlesBannerA = TypeA;
const ArticlesBannerB = TypeB;

export  { ArticlesBannerA, ArticlesBannerB };



// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/ArticlesBanner/index.js